// Mock data for Yamauchi Ramen Restaurant - Bilingual (ES/EN)

export const mockData = {
  // Hero Section
  hero: {
    headline: "El mejor ramen de la montaña",
    subheadline: "Inspired by Japanese gastronomy with a Puerto Rican twist. Discover the taste and freshness of the mountains.",
    heroImage: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/2q7e6g08_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2006_30_21%20PM.png"
  },

  // Three Pillars Section - Bilingual
  pillars: [
    {
      number: "01",
      tag: { es: "Artesanal", en: "Handcrafted" },
      name: { es: "Fideos de la Montaña", en: "Mountain Noodles" },
      description: {
        es: "Elaborados a diario con técnicas japonesas tradicionales. Cada hebra lleva la frescura del aire de Cayey.",
        en: "Made daily with traditional Japanese techniques. Every strand carries the freshness of Cayey's mountain air."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/qybzg4v0_IMG_5783.jpeg"
    },
    {
      number: "02",
      tag: { es: "Coctelería", en: "Cocktails" },
      name: { es: "Coctelería Japonesa", en: "Japanese Cocktails" },
      description: {
        es: "Cócteles de autor inspirados en el sake y el yuzu. Una fusión que sorprende en cada sorbo.",
        en: "Signature cocktails inspired by sake and yuzu. A fusion that surprises with every sip."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/r0hxfj2y_c5b659aa-013d-49bf-9ea8-4eb9d1069d35.jpeg"
    },
    {
      number: "03",
      tag: { es: "Alma del Ramen", en: "Soul of Ramen" },
      name: { es: "Caldos bien pensados", en: "Well-Crafted Broths" },
      description: {
        es: "Tonkotsu y broths cocinados lentamente. La profundidad que solo el tiempo puede crear.",
        en: "Slow-cooked tonkotsu and broths. The depth that only time can create."
      },
      image: "https://images.unsplash.com/photo-1616653872600-d6461f1b7905?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
    }
  ],

  // Contact
  contact: {
    email: "yamauchi.cayey@gmail.com",
    phone: "+19395933353"
  },

  // About Section - Bilingual
  about: {
    es: {
      title: "Sobre Nosotros",
      subtitle: "La historia de Yamauchi como el único ramen shop especializado en las montañas de Puerto Rico",
      description: "En Yamauchi, creemos que el ramen es más que un plato: es un viaje de sabor, cultura y conexión. Ubicados en el corazón de las montañas de Cayey, nos enorgullece ser el único restaurante en Puerto Rico dedicado exclusivamente al ramen en la región montañosa.",
      description2: "Nuestra historia comenzó con una misión simple: llevar la calidez y profundidad del ramen japonés al aire fresco de las montañas borinqueñas, con un toque auténtico de nuestra isla. Cada bowl se elabora con dedicación —desde nuestros fideos hechos en casa, hasta el pollo cocido en sous vide y caldos llenos de sabor y textura.",
      description3: "Pero Yamauchi va más allá de la comida. Estamos construyendo una comunidad que celebra la naturaleza y la cultura. A través de nuestro programa de afiliados, donamos ramen a creadores de contenido locales que exploran las bellezas naturales de Puerto Rico —haciendo que Yamauchi forme parte de sus spots favoritos en la montaña.",
      description4: "Desde nuestra cocina hasta los senderos, te invitamos a probar lo mejor de ambos mundos: la tradición japonesa y la identidad puertorriqueña, en cada bowl."
    },
    en: {
      title: "About Us",
      subtitle: "The story of Yamauchi as the only specialized ramen shop in the mountains of Puerto Rico",
      description: "At Yamauchi, we believe ramen is more than a dish: it's a journey of flavor, culture, and connection. Located in the heart of the Cayey mountains, we're proud to be the only restaurant in Puerto Rico dedicated exclusively to ramen in the mountain region.",
      description2: "Our story began with a simple mission: to bring the warmth and depth of Japanese ramen to the fresh mountain air of Puerto Rico, with an authentic island touch. Every bowl is crafted with dedication—from our homemade noodles to the sous vide chicken and broths full of flavor and texture.",
      description3: "But Yamauchi goes beyond food. We're building a community that celebrates nature and culture. Through our affiliate program, we donate ramen to local content creators who explore the natural beauty of Puerto Rico—making Yamauchi part of their favorite mountain spots.",
      description4: "From our kitchen to the trails, we invite you to taste the best of both worlds: Japanese tradition and Puerto Rican identity, in every bowl."
    },
    image: "https://customer-assets.emergentagent.com/job_ramen-pr/artifacts/6rtbmyt5_IMG_4504.jpeg"
  },

  // Trending Images
  trending: [
    {
      id: 1,
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/vxsyeyoq_566B8288-6753-4278-B789-37B7F008B85A.png",
      alt: { es: "Takoyakis de pulpo - Nuevos en Yamauchi", en: "Octopus takoyakis - New at Yamauchi" },
      tag: { es: "Nuevo", en: "New" },
      title: { es: "Takoyakis de Pulpo", en: "Octopus Takoyakis" },
      subtitle: { es: "Tu próxima obsesión.", en: "Your next obsession." }
    },
    {
      id: 2,
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/ech3fksh_8084B54D-5734-4BAC-A2F5-1DCA7B7062B7.png",
      alt: { es: "Yama-Gyoza - Nuevos en Yamauchi", en: "Yama-Gyoza - New at Yamauchi" },
      tag: { es: "Nuevo", en: "New" },
      title: { es: "Yama-Gyoza", en: "Yama-Gyoza" },
      subtitle: { es: "Tu próxima obsesión.", en: "Your next obsession." }
    },
    {
      id: 3,
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/2xlprfb8_AE48D4EA-B494-458F-8309-28B0F23B69B1.png",
      alt: { es: "Japón se sirve en la montaña - Cervezas y coctelería japonesa", en: "Japan served in the mountains - Japanese beers and cocktails" },
      tag: { es: "Nuevo", en: "New" },
      title: { es: "Japón se sirve en la montaña", en: "Japan served in the mountains" },
      subtitle: { es: "Nueva selección de cervezas y coctelería japonesa.", en: "New selection of Japanese beers and cocktails." }
    }
  ],

  // Menu Items - Bilingual
  menu: [
    // Ramen Section
    {
      id: 1,
      name: "Togawa Ramen",
      price: "$17.00",
      description: {
        es: "Caldo de pollo \"Chintan\" acompañado de fideos de la casa, huevo marinado, pollo sousvide y vegetales frescos.",
        en: "Chicken \"Chintan\" broth served with house noodles, marinated egg, sous vide chicken and fresh vegetables."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-pr/artifacts/qf6uwkbs_IMG_3794.jpeg",
      category: { es: "Ramen", en: "Ramen" }
    },
    {
      id: 2,
      name: "Borikotsu Ramen",
      price: "$17.00",
      description: {
        es: "Cremoso caldo de cerdo acompañado de fideos de la casa, lomo de cerdo marinado y vegetales frescos.",
        en: "Creamy pork broth served with house noodles, marinated pork loin and fresh vegetables."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-fullstack/artifacts/jvj6gfnv_E150E133-DF64-4D60-963A-59662999FBAC.png",
      category: { es: "Ramen", en: "Ramen" }
    },
    {
      id: 3,
      name: "Nitaino Ramen",
      price: "$17.00",
      description: {
        es: "Ramen 100% vegano, a base de vegetales y shitake, acompañado de brócoli, vegetales frescos y zetas marinadas.",
        en: "100% vegan ramen, vegetable and shiitake based, served with broccoli, fresh vegetables and marinated mushrooms."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-pr/artifacts/qxne22yz_IMG_3800.jpeg",
      vegan: true,
      category: { es: "Ramen", en: "Ramen" }
    },
    {
      id: 4,
      name: "BoriTori Ramen (Meat Lovers)",
      price: "$20.00",
      description: {
        es: "Ramen con lomo de cerdo, pollo sous vide y carne molida en un jugoso caldo de cerdo, acompañado de huevo marinado y vegetales frescos.",
        en: "Ramen with pork loin, sous vide chicken and ground beef in a juicy pork broth, served with marinated egg and fresh vegetables."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-fullstack/artifacts/cn8nzcc2_68FA7CC4-CDA6-4010-A59B-B95B30CF83A3.png",
      category: { es: "Ramen Especialidad", en: "Specialty Ramen" }
    },
    // Ramen Especialidad Section
    {
      id: 16,
      name: "Kuro-Kotsu",
      price: "$19.00",
      description: {
        es: "Caldo tonkotsu con aceite de ajo (Mayu) ajo rostizado y cerdo.",
        en: "Tonkotsu broth with garlic oil (Mayu), roasted garlic and pork."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-fullstack/artifacts/itbf5a2u_730E3C9D-F612-46A5-A601-A36A982BC1C0.png",
      category: { es: "Ramen Especialidad", en: "Specialty Ramen" }
    },
    {
      id: 17,
      name: "Kimchi Ramyeon",
      price: "$19.00",
      description: {
        es: "Caldo con base de kimchi, acompañado de pollo, kimchi \"de la casa\", huevo marinado, aceite de ajo negro y vegetales frescos.",
        en: "Kimchi-based broth served with chicken, house kimchi, marinated egg, black garlic oil and fresh vegetables."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-fullstack/artifacts/yb1bzsgb_10ECC952-0D58-4B05-82A6-FA784CCA9D80.png",
      category: { es: "Ramen Especialidad", en: "Specialty Ramen" }
    },
    // Combos Section
    {
      id: 5,
      name: "Bori Trip",
      price: "$30.00",
      description: {
        es: "Boritori, takoyakis (3 pz), mitarashi dango y soda japonesa.",
        en: "Boritori, takoyakis (3 pc), mitarashi dango and Japanese soda."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/zgazzw4g_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_18_25%20PM.png",
      category: { es: "Combos", en: "Combos" }
    },
    {
      id: 6,
      name: "Sweet Togawa",
      price: "$28.00",
      description: {
        es: "Togawa, Yama-Gyoza (2 pz), ichigo sando y soda japonesa.",
        en: "Togawa, Yama-Gyoza (2 pc), ichigo sando and Japanese soda."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/y1k7jddc_3A5E05FE-4E3C-44C6-9084-6240AA9458A3.png",
      category: { es: "Combos", en: "Combos" }
    },
    {
      id: 41,
      name: "Bori Izakaya",
      price: "$40.00",
      description: {
        es: "BoriTori, Takoyakis (3 piezas), Ichigo Sando y Soyu.",
        en: "BoriTori, Takoyakis (3 pieces), Ichigo Sando and Soju."
      },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/s61onooc_4DCC1C86-4144-4195-BEB8-F81FE7C93E9A.PNG",
      category: { es: "Combos", en: "Combos" }
    },
    {
      id: 42,
      name: "Nitayú Kaiso",
      price: "$29.00",
      description: {
        es: "Nitayú, Kaiso Yama, Mitarashi Dango y soda japonesa.",
        en: "Nitayú, Kaiso Yama, Mitarashi Dango and Japanese soda."
      },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/mxer7jz4_ChatGPT%20Image%20Aug%208%2C%202026%2C%2004_26_04%20AM.png",
      vegan: true,
      category: { es: "Combos", en: "Combos" }
    },
    // Aperitivo Section  
    {
      id: 19,
      name: "Takoyakis",
      price: "$8 (6 pz) / $12 (10 pz)",
      description: {
        es: "Bocados de pulpo con salsa tradicional, bonito flakes y cebollines (6 pz).",
        en: "Octopus bites with traditional sauce, bonito flakes and scallions (6 pc)."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/micc6266_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_18_34%20PM.png",
      category: { es: "Aperitivos", en: "Appetizers" }
    },
    {
      id: 20,
      name: "Yama-Gyoza",
      price: "$8 (5 pz) / $14 (10 pz)",
      description: {
        es: "Cerdo, exterior dorado y crujiente, acompañado de salsa tradicional (5 pz).",
        en: "Pork, golden and crispy exterior, served with traditional sauce (5 pc)."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/ckxq9hv9_IMG_6500.jpeg",
      category: { es: "Aperitivos", en: "Appetizers" }
    },
    // Postre Section
    {
      id: 10,
      name: "Ichigo Sando",
      price: "$5.00",
      description: {
        es: "Fresas frescas en crema batida dulce entre rebanadas de pan suave.",
        en: "Fresh strawberries in sweet whipped cream between slices of soft bread."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-fullstack/artifacts/z62vbbqq_F54CBB29-AD4B-4086-8B29-18EDD9B6B047.png",
      category: { es: "Postre", en: "Dessert" }
    },
    {
      id: 11,
      name: "Mitarashi Dango",
      price: "$4.50",
      description: {
        es: "Bolitas de arroz glutinado ligeramente tostadas, cubiertas con una salsa dulce de soya caramelizada.",
        en: "Lightly toasted glutinous rice balls, covered with a sweet caramelized soy sauce."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-fullstack/artifacts/ligqryd8_ED2F378A-603A-4DA1-BD33-CBBAFD92A169.png",
      vegan: true,
      category: { es: "Postre", en: "Dessert" }
    },
    // Bebidas Section
    {
      id: 12,
      name: "Coca-Cola",
      price: "$2.00",
      description: {
        es: "Refrescante bebida gaseosa clásica.",
        en: "Refreshing classic soda."
      },
      image: "https://images.unsplash.com/photo-1554866585-cd94860890b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      category: { es: "Bebidas", en: "Drinks" }
    },
    {
      id: 13,
      name: "Sprite",
      price: "$2.00", 
      description: {
        es: "Refrescante bebida gaseosa de limón-lima.",
        en: "Refreshing lemon-lime soda."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-pr/artifacts/7w9v07r7_IMG_4482.jpeg",
      category: { es: "Bebidas", en: "Drinks" }
    },
    {
      id: 14,
      name: "Agua",
      price: "$1.50",
      description: {
        es: "Agua purificada fresca y natural.",
        en: "Fresh and natural purified water."
      },
      image: "https://customer-assets.emergentagent.com/job_ramen-pr/artifacts/nyt1xxch_IMG_4483.jpeg",
      category: { es: "Bebidas", en: "Drinks" }
    },
    {
      id: 15,
      name: { es: "Sodas Japonesas", en: "Japanese Sodas" },
      price: "$4.00",
      description: {
        es: "Sabores de temporada.",
        en: "Seasonal flavors."
      },
      image: "https://customer-assets.emergentagent.com/job_menu-makeover-10/artifacts/mmwxlna8_E919EAC1-ABC4-4D09-8317-277CB5A73E63.png",
      category: { es: "Bebidas", en: "Drinks" }
    },
    // Coctelería Japonesa Section
    {
      id: 21,
      name: "Yamauchee Gimlet",
      price: "$14.00",
      description: {
        es: "Gin japonés, lychee, yuzu.",
        en: "Japanese gin, lychee, yuzu."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/dha97ljq_4BA509FF-C5A0-45CF-86FD-890DDAE53AC2.png",
      category: { es: "Coctelería Japonesa", en: "Japanese Cocktails" }
    },
    {
      id: 22,
      name: "Santōryū Highball",
      price: "$12.00",
      description: {
        es: "Toki whisky, agua carbonatada.",
        en: "Toki whisky, carbonated water."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/w2x8w8qj_D00C2D01-6436-4CBB-8A84-0FB227F31218.png",
      category: { es: "Coctelería Japonesa", en: "Japanese Cocktails" }
    },
    {
      id: 23,
      name: "Nankurunaisa",
      price: "$16.00",
      description: {
        es: "Whisky, yuzu, licor de jengibre, reducción de vino de ciruela, aceite de sésamo.",
        en: "Whisky, yuzu, ginger liqueur, plum wine reduction, sesame oil."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/s7jz7el1_78C33079-F4B9-4A7F-A158-CA7BD4CFE8F2.png",
      category: { es: "Coctelería Japonesa", en: "Japanese Cocktails" }
    },
    {
      id: 24,
      name: "Sakazuki",
      price: "$12.00",
      description: {
        es: "Sake, pomelo, jengibre, yuzu, semillas de sésamo.",
        en: "Sake, grapefruit, ginger, yuzu, sesame seeds."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/74unhzib_B6FCA036-8019-4DD7-885F-64C2E721EF24.png",
      category: { es: "Coctelería Japonesa", en: "Japanese Cocktails" }
    },
    // Cervezas Japonesas Section
    {
      id: 25,
      name: "Sake Jelly Shot",
      price: "$8.00",
      description: {
        es: "Jelly shot de berries.",
        en: "Berry jelly shot."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/5ot4gjnc_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_30_37%20PM.png",
      category: { es: "Cervezas Japonesas", en: "Japanese Beers" }
    },
    {
      id: 27,
      name: "Echigo",
      price: "$12.50",
      description: {
        es: "Refrescante lager japonesa.",
        en: "Refreshing Japanese lager."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/7d5ckfpz_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_31_07%20PM.png",
      category: { es: "Cervezas Japonesas", en: "Japanese Beers" }
    },
    {
      id: 28,
      name: "Kyoto",
      price: "$12.50",
      description: {
        es: "Matcha, cítrica y herbal.",
        en: "Matcha, citrus and herbal."
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/b74bhfd7_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_30_32%20PM.png",
      category: { es: "Cervezas Japonesas", en: "Japanese Beers" }
    },
    // Cervezas Section
    {
      id: 29,
      name: "Lucky Budha",
      price: "$5.50",
      description: {
        es: "",
        en: ""
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/3o3g6b43_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_38_24%20PM.png",
      category: { es: "Cervezas", en: "Beers" }
    },
    {
      id: 31,
      name: "Soyu (shot)",
      price: "$4.00",
      description: {
        es: "",
        en: ""
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/fo7ujewa_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_41_07%20PM.png",
      category: { es: "Cervezas", en: "Beers" }
    },
    {
      id: 32,
      name: "Soyu",
      price: "$15.00",
      description: {
        es: "",
        en: ""
      },
      image: "https://customer-assets.emergentagent.com/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/pxva6b06_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_38_51%20PM.png",
      category: { es: "Cervezas", en: "Beers" }
    },
    // Boba / Refreshers Section
    {
      id: 33,
      name: "Milky Strawberry",
      price: "$8.00",
      description: { es: "", en: "" },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/f51myp9s_IMG_9116.JPG",
      tag: { es: "Boba", en: "Boba" },
      category: { es: "Boba/Refreshers", en: "Boba/Refreshers" }
    },
    {
      id: 34,
      name: "Strawberry",
      price: "$8.00",
      description: { es: "", en: "" },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/mjeu1y9s_Strawberry%20Refresher.png",
      tag: { es: "Refresher", en: "Refresher" },
      category: { es: "Boba/Refreshers", en: "Boba/Refreshers" }
    },
    {
      id: 35,
      name: "Taro",
      price: "$8.00",
      description: { es: "", en: "" },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/dc4g6tkz_ChatGPT%20Image%20Jul%2018%2C%202026%2C%2008_03_06%20PM%20%281%29.png",
      tag: { es: "Boba", en: "Boba" },
      category: { es: "Boba/Refreshers", en: "Boba/Refreshers" }
    },
    {
      id: 36,
      name: "Brown Sugar",
      price: "$8.00",
      description: { es: "", en: "" },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/kuah30le_Brown%20suggar%202.png",
      tag: { es: "Boba", en: "Boba" },
      category: { es: "Boba/Refreshers", en: "Boba/Refreshers" }
    },
    {
      id: 37,
      name: "Kaiso Yama",
      price: "$7.00",
      description: {
        es: "Fresca ensalada de seaweed con tofu crumble.",
        en: "Fresh seaweed salad with tofu crumble."
      },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/pd2z35p0_IMG_4034.webp",
      vegan: true,
      category: { es: "Aperitivos", en: "Appetizers" }
    },
    {
      id: 38,
      name: "Nitayú",
      price: "$19.00",
      description: {
        es: "Caldo vegano, vegetales, zetas marinadas, tofu crumble y seaweed.",
        en: "Vegan broth, vegetables, marinated mushrooms, tofu crumble and seaweed."
      },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/hjf18mcf_IMG_4256.webp",
      vegan: true,
      category: { es: "Ramen Especialidad", en: "Specialty Ramen" }
    },
    {
      id: 39,
      name: "Parcha",
      price: "$8.00",
      description: { es: "", en: "" },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/0361w9qh_Boba%20Parcha%202.png",
      tag: { es: "Refresher", en: "Refresher" },
      category: { es: "Boba/Refreshers", en: "Boba/Refreshers" }
    },
    {
      id: 40,
      name: "Matcha",
      price: "$8.00",
      description: { es: "", en: "" },
      image: "https://customer-assets-jt897jd0.emergentagent.net/job_454112df-86b9-45bf-b8cc-bd9811dec4e0/artifacts/1r4yaqzk_ChatGPT%20Image%20Jul%2018%2C%202026%2C%2007_50_40%20PM%20%281%29.png",
      tag: { es: "Boba", en: "Boba" },
      category: { es: "Boba/Refreshers", en: "Boba/Refreshers" }
    }
  ],

  // Gallery Images
  gallery: [],

  // Location and Hours
  location: {
    address: "Urb. C1 Cll 14, Cayey, PR 00633",
    hours: {
      thursday: "12 PM – 9:30 PM",
      friday: "12 PM – 9:30 PM",
      saturday: "12 PM – 9:30 PM",
      sunday: "1 PM – 7 PM",
      monday: "Cerrado",
      tuesday: "Cerrado",
      wednesday: "Cerrado"
    },
    links: {
      googleMaps: "https://maps.app.goo.gl/7Sb8UPTvVEhNWGss6?g_st=ipc",
      uberEats: "https://www.ubereats.com/",
      instagram: "https://www.instagram.com/yamauchiramenpr?igsh=a2dobzBnaTNzNGlq&utm_source=qr",
      tiktok: "https://www.tiktok.com/@yamauchiramenpr?_t=ZT-8yczEXL25CR&_r=1",
      facebook: "https://www.facebook.com/share/16kgdyrhcQ/?mibextid=wwXIfr"
    }
  },

  // Reviews (legacy - now using Google Reviews API)
  reviews: [],

  // Affiliate Program - Bilingual
  affiliateProgram: {
    es: {
      title: "Ramen para los que aman la naturaleza",
      subtitle: "¿Eres creador de contenido, amante del hiking o explorador de los rincones naturales de Puerto Rico?",
      description: "En Yamauchi, creemos que el ramen se disfruta mejor donde el alma se siente más viva — en el corazón de las montañas puertorriqueñas. Por eso creamos el Programa de Afiliados Yamauchi, un proyecto que apoya a creadores que exploran y promueven la belleza natural de nuestra isla.",
      offers: [
        "Donamos ramen a afiliados aprobados",
        "Lo disfrutas en tu lugar natural favorito", 
        "Capturas el momento en fotos o video",
        "Te destacamos en nuestra web y redes sociales"
      ],
      target: "Ya seas fotógrafo, senderista, piloto de dron o amante de la naturaleza — si te apasiona Puerto Rico y el buen ramen, este programa es para ti.",
      cta: "Aplica ahora y deja que tu próxima aventura empiece con ramen."
    },
    en: {
      title: "Ramen for nature lovers",
      subtitle: "Are you a content creator, hiking enthusiast, or explorer of Puerto Rico's natural wonders?",
      description: "At Yamauchi, we believe ramen is best enjoyed where the soul feels most alive—in the heart of Puerto Rico's mountains. That's why we created the Yamauchi Affiliate Program, a project that supports creators who explore and promote the natural beauty of our island.",
      offers: [
        "We donate ramen to approved affiliates",
        "Enjoy it at your favorite natural spot",
        "Capture the moment in photos or video",
        "We feature you on our website and social media"
      ],
      target: "Whether you're a photographer, hiker, drone pilot, or nature lover—if you're passionate about Puerto Rico and great ramen, this program is for you.",
      cta: "Apply now and let your next adventure begin with ramen."
    }
  }
};

export default mockData;
